export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8170.3c010a47.jpg";